export enum SHModules {
  Prospect = 'prospect',
  Sequence = 'sequence',
}
